import React from 'react';
import PropTypes from 'prop-types';
import s from './ReleaseNoteList.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import moment from 'moment-timezone';
import Button from 'react-bootstrap/Button';
import ascendingIcon from '../../assets/arrow-sort-up.svg';
import descendingIcon from '../../assets/arrow-sort-down.svg';

const ReleaseNoteListTable = ({
  paginatedData = [],
  onRemoveClick,
  onReleaseNoteSelection,
  UpdateAllowed,
  onSortOrder,
  asendingOrder,
  currentTimezone
}) => {
  const deleteDataHandler = (id, guid) => {
    onRemoveClick(id);
  };

  let sortIcon = asendingOrder ? ascendingIcon : descendingIcon;

  return (
    <div className={s.wsTableContainer}>
      <Table variant className={s.wsTable}>
        <thead>
          <tr>
            <th className={` ${s.sortHeading} ${s.leftBorderColor}`}>
              <span onClick={onSortOrder}>
                <FormattedMessage id="releaseNotes.name" defaultMessage="Name" /> <img className={s.sortIcon} src={sortIcon} alt="icon" />{' '}
              </span>
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="releaseNotes.platformName" defaultMessage="Platform Name" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="releaseNotes.version" defaultMessage="Version" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="releaseNotes.published" defaultMessage="Published" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="releaseNotes.dateCreated" defaultMessage="Date created" />
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <tr key={n.ReleaseNoteId} data-unittest="releaseNoteData">
                <td className={n.IsPublished ? s.borderGreen : s.borderYellow}>{n.Name || ''}</td>
                <td className="d-none d-md-table-cell">{n.PlatformName || ''}</td>
                <td className="d-none d-md-table-cell">{n.VersionNo || ''}</td>
                <td className="d-none d-md-table-cell">
                  {n.IsPublished ? (
                    <FormattedMessage id="common.yes" defaultMessage="Yes" />
                  ) : (
                    <FormattedMessage id="common.no" defaultMessage="No" />
                  )}
                </td>
                <td className="d-none d-md-table-cell">
                  {n.CreatedDateTime
                    ? moment(parseInt(n.CreatedDateTime * 1000))
                      .tz(currentTimezone)
                      .format('DD-MMM-YYYY z')
                    : '-'}
                </td>

                <td>
                  {UpdateAllowed && (

                    <div>
                      <Button
                        variant="outline-secondary"
                        className={s.changeButton}
                        onClick={onReleaseNoteSelection.bind(this, n.ReleaseNoteId, n.GuidIdentifier)}
                        data-unittest="changeData"
                      >
                        <FormattedMessage id="common.ledit" defaultMessage="Edit" />
                      </Button>
                      <Button
                        variant="outline-secondary"
                        className={s.removeButton}
                        onClick={deleteDataHandler.bind(this, n.ReleaseNoteId, n.GuidIdentifier)}
                        data-unittest="deleteData"
                      >
                        <FormattedMessage id="releaseNotes.remove" defaultMessage="Remove" />
                      </Button>

                    </div>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};


ReleaseNoteListTable.propTypes = {
  currentTimezone: PropTypes.string.isRequired
};

export default injectIntl(ReleaseNoteListTable);
